import { useRouteMatch } from 'react-router-dom';
import { z } from 'zod';

const idSchema = z.object({ id: z.coerce.number() }).transform(({ id }) => id);

export const useIdParam = () => {
  const { params } = useRouteMatch();
  return idSchema.parse(params);
};
